import { CalendarSettingsViewModel } from "../api/calendar-settings"

export const makeCalendarSettingsKey = (calendarSettings?: CalendarSettingsViewModel): string => {
  if (!calendarSettings) return ""

  const weekendKey = calendarSettings.weekendDays.join(",")
  const fixedHolidayKey = calendarSettings.fixedHolidays.join("|")
  const recurringHolidayKey = calendarSettings.recurringHolidays.join("|")

  return [
    calendarSettings.id,
    calendarSettings.firstDayOfWeek,
    weekendKey,
    fixedHolidayKey,
    recurringHolidayKey,
    calendarSettings.dateFnsDateFormat,
    calendarSettings.timeZone,
  ].join("-")
}
